import {BaseContainerModel} from '../base-container.model';
import { app_auth_passwordless_login_with_authentication_RowClass } from '../../dbschema';

export class AppPasswordlessLoginContainer extends BaseContainerModel {
  app_auth_passwordless_login_with_authentication: app_auth_passwordless_login_with_authentication_RowClass = new app_auth_passwordless_login_with_authentication_RowClass();
}
